import React from 'react';

import GettingStartedView from 'components/GettingStartedView';
import InstitutionBackupsPage from 'institutions/InstitutionBackupsPage';
import DatadogUtil from 'performance/DatadogUtil';
import {RouteBundle} from 'routing/RouteConstants';
import {renderReactElement} from 'util/RootReactRender';

export const InstitutionsRoutes: RouteBundle = {
  domain: 'institutions',
  routes: [
    {urlPattern: ':institutionUrlIdentifier/signup', handler: institution, legacy: true},
    {urlPattern: 'account/institution-backups', handler: institutionBackups},
  ],
};

function institution(): void {
  DatadogUtil.startRUMView('signup_institution');
  new GettingStartedView({el: $('.sign-up')}).render();
}

function institutionBackups(): void {
  DatadogUtil.startRUMView('institution_backups');
  renderReactElement(<InstitutionBackupsPage />);
}
